import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  base: '/',
  mode: 'history',

  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import(/* webpackChunkName: "index" */ './views/Index/Index.vue'),
    },
    {
      path: '/partner-info',
      name: 'partner-info',
      meta: { title: 'Партнерам' },
      component: () => import(/* webpackChunkName: "partner-info" */ './views/PartnerInfo/PartnerInfo.vue'),
    },
    {
      path: '/sign-up',
      name: 'sign-up',
      meta: { title: 'Регистрация' },
      component: () => import(/* webpackChunkName: "sign-up" */ './views/Authorize/SignUp/SignUp.vue'),
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      meta: { title: 'Авторизация' },
      component: () => import(/* webpackChunkName: "sign-in" */ './views/Authorize/SignIn/SignIn.vue'),
    },
    {
      path: '/restore-password',
      name: 'restore-password',
      meta: { title: 'Восстановление пароля' },
      component: () => import(/* webpackChunkName: "restore-password" */ './views/Authorize/RestorePassword/RestorePassword.vue'),
    },
    {
      path: '/change-password/:code',
      name: 'change-password',
      meta: { title: 'Изменение пароля' },
      component: () => import(/* webpackChunkName: "change-password" */ './views/Authorize/RestorePassword/ChangePassword.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Loy';

  next();
});

export default router;
